import { Component, OnInit } from '@angular/core';
import { AlertController, ModalController, NavController, ToastController } from '@ionic/angular';
import { ModalSettingsComponent } from 'src/app/components/modals/modal-settings/modal-settings.component';
import { BankAccountViewModel } from 'src/app/models/bankAccountViewModel';
import { BankService } from 'src/app/services/bank.service';

@Component({
  selector: 'app-bank-list',
  templateUrl: './bank-list.page.html',
  styleUrls: ['./bank-list.page.scss'],
})
export class BankListPage implements OnInit {

  public banks: BankAccountViewModel[] = [];

  constructor(private service: BankService, private toastCtrl: ToastController, private modalCtrl: ModalController, 
                    private navCtrl: NavController, private alertController: AlertController) { }

  ngOnInit() {
    this.service.getAllByUser().subscribe(result => {
      if (result.success) {
        this.banks = result.data;
      }
    });
  }

  async showModalSettings() {
    const modal = await this.modalCtrl.create({
      component: ModalSettingsComponent
    });
    modal.present();
  }

  async confirmeDelete(id: string) {
    const alert = await this.alertController.create({
      header: 'Deletar conta',
      message: `Deseja realmente deletar esta conta ?`,
      buttons: [
        {
          text: 'Voltar',
          role: 'cancel',
        },
        {
          text: 'Deletar',
          handler: () => {
            this.delete(id);
          }
        }
      ]
    });
    await alert.present();
  }

  delete(id: string) {
    this.service.delete(id).subscribe(result => {
      if (result.success) {
        this.showMessage(result.message);
        this.ngOnInit();
      }
    });
  }

  goToPage(page: string) {
    this.navCtrl.navigateForward('/master/wallet/bank/' + page +'/edit');
  }

  async showMessage(messagen) {
    const error = await this.toastCtrl.create({ message: messagen, duration: 3000 });
    error.present();
  }

  async addBank() {
    this.navCtrl.navigateForward('/master/wallet/bank/new');
  }

}
